import {
  GetWorkflowRequestBody,
  ListWorkflowRequestBody,
  MultipleWorkflowRunResult,
  ReRunMultipleWorkflowRequestBody,
  ReRunWorkflowRequestBody,
  WorkflowRunResult,
  WorkflowRunLogsResponse,
} from '@internal/backstage-plugin-cloudbuild-common';
import { createApiRef } from '@backstage/core-plugin-api';
import {
  ActionsGetWorkflowResponseData,
  ActionsListWorkflowRunsForRepoResponseData,
} from './types';

/** @public */
export const workflowApiRef = createApiRef<WorkflowApi>({
  id: 'plugin.cloudbuild.service',
});

/** @public */
export type WorkflowApi = {
  listWorkflowRuns: (
    options: ListWorkflowRequestBody,
  ) => Promise<ActionsListWorkflowRunsForRepoResponseData>;
  getWorkflow: (
    options: GetWorkflowRequestBody,
  ) => Promise<ActionsGetWorkflowResponseData>;
  getWorkflowRun: (
    options: GetWorkflowRequestBody,
  ) => Promise<ActionsGetWorkflowResponseData>;
  reRunWorkflow: (
    options: ReRunWorkflowRequestBody,
  ) => Promise<WorkflowRunResult>;
  reRunMultipleWorkflows: (
    options: ReRunMultipleWorkflowRequestBody,
  ) => Promise<MultipleWorkflowRunResult>;
  getWorkflowLogs: (
    options: GetWorkflowRequestBody,
  ) => Promise<WorkflowRunLogsResponse | null>;
  invalidateCache?: () => void;
};
